import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import { useStyles } from './styles';
import { throttle } from 'lodash';
import SpinLoading from 'common/components/spin-loading';

const CheckBoxGroup = props => {
  const { options, value, onChange, onScrollEnd, isLoading } = props;
  const classes = useStyles();

  const handleScroll = useCallback(
    throttle(e => {
      const preOffset = 10;
      if (
        !isLoading &&
        e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - preOffset
      ) {
        onScrollEnd?.();
      }
    }, 500),
    [],
  );

  return (
    <div className={classes.filterDropdownBox} data-test-id="dropdown_option_list">
      <Checkbox.Group options={options} value={value} onChange={onChange} onScroll={handleScroll} />
      {isLoading && <SpinLoading className={classes.loading} />}
    </div>
  );
};
CheckBoxGroup.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default CheckBoxGroup;
